import React from 'react';
import { usePage, useAuth } from 'api';
import { useParams, Redirect } from 'react-router-dom';

export default function(props) {
  
  const auth = useAuth();
  const companyId = auth ? auth.company.id : null;
  const {pageId} = useParams();
  const page = usePage(companyId, pageId);
  
  if(!page) {
    return null;
  }
  
  if(!page.type) {
    return <Redirect to="type"/>;
  }
  
  return <Redirect to={page.type}/>;
  
}